attachEvent('.accordion-single__title', 'click', (ev) => {
  const parentElem = ev.target.closest('.accordion-single');
  const content = parentElem.querySelector('.accordion-single__content');
  parentElem.classList.toggle('is-open');
  slideToggle(content, 300, 'block');
});
